/* eslint-disable max-len */
export const getRoles = (state) => state.permissions.roles && state.permissions.roles.data.roles;
export const getSettings = (state) =>
	state.permissions.settings && state.permissions.settings.data.settings;
export const getPermissions = (state) =>
	state.permissions.settings && state.permissions.settings.data.permissions;
export const getRolesData = (state) => state.permissions.rolesData;
